<template>

    <div id="side_menu" v-if="item">

      <div id="menu_logo"></div>
      
		<ul>

			<li v-for="widget in widgets" :key="widget.id">
        <router-link v-on:click.native="$emit('close_login_pop')" v-if="widget.type != 'link' && widget.link != false && widget.link != '' && widget.link != undefined" :to="widget.link" v-text="widget.title" :class="((widget.link.indexOf('/home') != -1 && ($route.path == '/item/' + item.id || $route.path == '/item/' + item.id + '/')) ? 'router-link-active':'')"></router-link>
        <a v-else-if="widget.type == 'link'" v-text="widget.title" :href="widget.link" target="_blank"></a>
        <a v-else v-text="widget.title"></a>
        
        <div v-if="widget.type == 'download' && is_logged">
            <a  v-for="file in widget.files" :key="file.title" target="_blank" :href="file.url">{{ file.title }} <i class="fa fa-download"></i></a>
        </div>
        <div v-if="widget.type == 'download' && !is_logged">
            <a  v-for="file in widget.files" :key="file.title" @click="$emit('open_login_pop')">{{ file.title }} <i class="fa fa-download"></i></a>
        </div>
			</li>
        
			
		</ul>


    </div>

</template>

<script>
export default {
  props: ["widgets", "item", "user"],
  created(){
    
  },
  computed: {
    is_logged(){
      if (this.user)
      {
      return (this.user.id > 0);
      }
      return false;
    }
  }
}
</script>
